import {PatientTherapySequence} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {RevisePrescriptionDialog} from './revise-prescription-dialog'

export function openRevisePrescriptionDialog(sequence: PatientTherapySequence) {
  return dialog.open('add-parameter', {
    id: 'add-parameter',
    children: <RevisePrescriptionDialog sequence={sequence} />,
    size: 'cover',
    scrollBehavior: 'inside',
    contentProps: {
      overflow: 'hidden',
      height: 'max-content',
      maxWidth: '80rem',
    },
    hideCloseButton: true,
  })
}
